import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SignPreviewPageRoutingModule } from './sign-preview-routing.module';

import { SignPreviewPage } from './sign-preview.page';
import { SafeHtmlPipe } from 'src/app/_pipes/SafeHtml.Pipe';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    SignPreviewPageRoutingModule
  ],
  declarations: [SignPreviewPage],
})
export class SignPreviewPageModule {}
